<template>
    <div class="card rounded-8 border-0">
        <img 
            class="card-img-top" 
            src="/images/ruta_creada_exito_bg.png" 
            alt="Ruta creada exitosamente"
        >
        <div class="card-body p-5">
            <div class="mb-3">
                <h4 style="color:#1A0054">
                    Se ha creado con éxito la ruta "{{ info.name }}"
                </h4>
            </div>
            <div class="text-card-normal mb-3">
                <p class="text-muted">
                    La ruta ha sido asignada a {{ userCount }} {{ userCount === 1 ? 'colaborador' : 'colaboradores' }} 
                    y contiene {{ courseCount }} {{ courseCount === 1 ? 'curso' : 'cursos' }}.
                </p>
            </div>
            <div class="text-center">
                <button 
                    class="btn bg-utel text-white sin-borde rounded-8 px-5" 
                    @click="createNewRoute"
                >
                    Crear nueva ruta
                </button>
            </div>
        </div>
    </div>
</template>

<script>
const createEmptyRoute = () => ({
    name: '',
    description: '',
    courses: [],
    students: [],
    parentId: 0
});

export default {
    name: 'CreateCustomRouteConfirmation',
    props: {
        info: { type: Object, required: true }
    },
    emits: ['setRuta', 'changeStep'],
    computed: {
        userCount() {
            return this.info.students?.length || 0;
        },
        courseCount() {
            return this.info.courses?.length || 0;
        }
    },
    methods: {
        createNewRoute() {
            this.$emit('setRuta', createEmptyRoute());
            this.$emit('changeStep', 1);
        }
    }
};
</script>
